import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    imageBlock: {
        width: '70%',
        margin: '0 auto',
        [theme.breakpoints.down('769')]: {
            width: '90%'
        },
        marginTop: '2%'
    },
    coloredBox: {
        width: '70%',
        padding: '1%',
        backgroundColor: '#344450',
        height: '40vh',
        position: 'absolute',
        zIndex: -1,
        maxHeight: 150,
        minHeight: 50,
        [theme.breakpoints.down('769')]: {
            width: '90%',
            maxHeight: 70,
        },
        [theme.breakpoints.down('320')]: {
            maxHeight: 50,
        },
    },
    newsImage: {
        width: '98%',
        maxWidth: '98%',
        height: 'auto',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        // backgroundSize: 'cover',
        zIndex: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-end'
    },
    newImage: {
        margin: '0 auto',
        width: '80%',
        height: 'auto'
    },
    newsContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // padding: '2% 0'
    },
    newsTitle: {
        color: '#344450',
        padding: '1% 2%',
        margin: '1% 0',
        borderBottom: '3px solid #f5b750',
        fontSize: 24,
        [theme.breakpoints.down('1100')]: {
            fontSize: 20
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 18
        }
    },
    newsDate: {
        color: '#344450',
        fontSize: 18,
        marginBottom: '1%',
        [theme.breakpoints.down('1100')]: {
            fontSize: 16
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 13
        }
    },
    newsText: {
        color: '#344450',
        lineHeight: '1.7em',
        width: '70%',
        marginTop: '1%',
        fontSize: 20,
        [theme.breakpoints.down('1100')]: {
            fontSize: 16,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 14,
            width: '80%'
        }
    },
    latestNewsContainer: {
        width: '90%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#E4E4E4',
        marginBottom: '5%',
        padding: '2% 1%',
        [theme.breakpoints.down('769')]: {
            width: '100%'
        },
    },
    latestNews: {
        display: 'flex',
        justifyContent: 'space-around',
        alignSelf: 'flex-end',
        width: '90%',
        marginTop: '2%',
        [theme.breakpoints.down('1100')]: {
            flexDirection: 'column',
            alignItems: 'center',
            alignSelf: 'center',
        },
    },
    latestNewsDiv: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        cursor: 'pointer',
        width: '28%',
        [theme.breakpoints.down('1100')]: {
            width: '50%'
        },
        [theme.breakpoints.down('769')]: {
            width: '60%',
            paddingBottom: '5%'
        },
        [theme.breakpoints.down('500')]: {
            width: '100%',
            paddingBottom: '5%'
        }
    },
    latestNewsBlock: {
        width: '90%',
        minHeight: 350,
        backgroundColor: 'white',
        boxShadow: '0px 3px 2px rgb(177, 174, 174)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '2%',
        [theme.breakpoints.down('1100')]: {
            minHeight:'auto'
        }
    },
    latestNewsTitle: {
        padding: '4%',
        fontSize: 18,
        fontWeight: 'bold',
        color: '#344450',    
        margin:'auto',
        textAlign:'center'    
    },
    latestNewsDate: {
        color: '#344450',
        fontSize: 16,
        fontWeight: '500',
        paddingTop: '5%',
        paddingBottom: '2%'
    },
    eventImage: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        height: 200,
        width: '100%',
    },

    interactionsSummary: {
        color: '#344450',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        alignContent: 'center',
        width: '40%',
        [theme.breakpoints.down('1100')]: {
            width: '50%',
        },
        [theme.breakpoints.down('769')]: {
            width: '90%',
        },
    },
    interactionsCount: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: 'fit-content',
    },
    interactionsText: {
        fontSize: 18,
        [theme.breakpoints.down('1100')]: {
            fontSize: 16,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 12,
        }
    },
    interactionsIcon: {
        fontSize: 20,
        marginRight: 5,
        [theme.breakpoints.down('1100')]: {
            fontSize: 18,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 12,
        }
    },
    icon: {
        fontSize: 22,
        width: '1.375em',
        height: '1em',
        color: '#344450',
        [theme.breakpoints.down('1100')]: {
            // fontSize: 16,
        },
        [theme.breakpoints.down('769')]: {
            // fontSize: 14,
        },
        '&:hover': {
            color: '#F5B750'
        }
    },
    imagesCount: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        margin: '0 auto',
        width: 'fit-content',
        bottom: 2
    },
    dot: {
        height: 10,
        width: 10,
        borderRadius: 30,
        margin: 5,
        [theme.breakpoints.down('700')]: {
            height: 7,
            width: 7,
            margin: 5,
        },
        [theme.breakpoints.down('400')]: {
            height: 5,
            width: 5,
            margin: 2.5,
        }
    },

}))

export default useStyles